<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
      <v-tab
        v-for="tab of tabs"
        class="common-font-size"
        :disabled="tab.id === 4 && !isprintWarrentNumber"
        :key="tab.id"
        @click="WarnUser(tab.to)"
        :id="`mtgTransSequenceTab${tab.id}`"
        :class="`mtg-trans-sequence-tab-${tab.id}`"
      >
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import '../assets/style.css';
import { mapActions } from 'vuex';
import CommonDropDownsMixins from '../components/tax/common-utils/CommonDropDowns.mixin.vue';

export default {
  name: 'Apportionment',
  mixins: [CommonDropDownsMixins],
  components: {
  },
  created() {
    this.getPathName(this.$route.path);
    this.loadDropDownList();
    this.loadGlobalConfig();
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/apportionment/taxes' }, caption: 'Taxes' },
      { id: 2, to: { path: '/apportionment/misc-mtg' }, caption: 'Misc & Mtg' },
      { id: 3, to: { path: '/apportionment/apportionment' }, caption: 'Apportionment' },
      { id: 4, to: { path: '/apportionment/warrants' }, caption: 'Remit Warrants' },
      { id: 5, to: { path: '/apportionment/reports' }, caption: 'Reports' },
      { id: 6, to: { path: '/apportionment/utils/appropriations' }, caption: 'Utils' },
    ],
    isprintWarrentNumber: false,
  }),
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    async loadDropDownList() {
      this.loadTaxDistrict({
        criteria: {
          sortBy: [{
            column: 'districtCode',
            direction: 'asc',
          }],
        },
        baseCrudKey: 'sharedTaxDistrict',
      });
      this.loadFiscalYearList({ postProcessTrans: this.postProccessTaxYearData });
      this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
    },
    getPathName(curPath) {
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      this.activetab = ftr[0].id !== undefined ? ftr[0].id - 1 : 0;
    },
    async loadGlobalConfig() {
      const apportionmentSetting = await this.loadConfig({ requiredScope: 'apportionmentConfig' });
      this.isprintWarrentNumber = (apportionmentSetting && apportionmentSetting.length > 0
        && apportionmentSetting[0]
        && apportionmentSetting[0].configuration)
        ? apportionmentSetting[0].configuration.treasurerPrintsWarrants
        : false;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },

};
</script>
